// extracted by mini-css-extract-plugin
module.exports = {"container":"FolderItem_container__k7bCq","icon":"FolderItem_icon__UdlsU","label":"FolderItem_label__KtJcS","actions":"FolderItem_actions__19M6f"};